'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _calendars = require('redux/modules/calendars');

var actions = _interopRequireWildcard(_calendars);

var _reactBootstrap = require('react-bootstrap');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventWidgetForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    calendar: state.calendars.calendar,
    hideRecurrences: state.hideRecurrences,
    loaded: state.calendars.loaded,
    loading: state.calendars.loading
  };
}, (0, _extends3.default)({}, actions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(EventWidgetForm, _Component);

  function EventWidgetForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EventWidgetForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EventWidgetForm.__proto__ || (0, _getPrototypeOf2.default)(EventWidgetForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      autofocus: false,
      copied: false,
      errors: {},
      height: 400,
      hideRecurrences: false,
      locale: 'fr',
      number: 6,
      organization: null,
      organizationId: null,
      popoverContainer: null,
      tags: [],
      tagsId: [],
      types: [],
      typesId: [],
      regions: [],
      width: 800
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EventWidgetForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          calendarId = _props.calendarId,
          find = _props.find;


      if (calendarId) {
        find(calendarId);
      } else {
        // Should not happen
        this.handleCloseModal();
      }
    }
  }, {
    key: 'handleChangeOrganization',
    value: function handleChangeOrganization(organization) {
      this.setState({ organization: organization, organizationId: organization ? organization.id : null });
    }
  }, {
    key: 'handleChangeTypes',
    value: function handleChangeTypes(types) {
      var tempIdsArray = [];
      types.map(function (type) {
        tempIdsArray.push(type.id);
      });
      this.setState({ types: types, typesId: tempIdsArray });
    }
  }, {
    key: 'handleChangeTags',
    value: function handleChangeTags(tags) {
      var tempIdsArray = [];
      tags.map(function (tag) {
        tempIdsArray.push(tag.id);
      });
      this.setState({ tags: tags, tagsId: tempIdsArray });
    }
  }, {
    key: 'handleChangeRegions',
    value: function handleChangeRegions(regions) {
      this.setState({ regions: regions });
    }
  }, {
    key: 'handleChangeRecurrence',
    value: function handleChangeRecurrence(_ref2) {
      var target = _ref2.target;

      this.setState({ hideRecurrences: target.checked });
    }
  }, {
    key: 'handleCopy',
    value: function handleCopy() {
      var _this2 = this;

      this.setState({ copied: true });

      setTimeout(function () {
        _this2.setState({ copied: false });
      }, 2000);
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.props.closeModal();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          calendar = _props2.calendar,
          loaded = _props2.loaded,
          loading = _props2.loading,
          polyglot = _props2.polyglot,
          requireCloseModal = _props2.requireCloseModal;
      var _state = this.state,
          errors = _state.errors,
          height = _state.height,
          hideRecurrences = _state.hideRecurrences,
          number = _state.number,
          organization = _state.organization,
          organizationId = _state.organizationId,
          tags = _state.tags,
          tagsId = _state.tagsId,
          types = _state.types,
          typesId = _state.typesId,
          regions = _state.regions,
          width = _state.width;


      var calendarUrl = 'http://caligram.com';
      if (calendar && calendar.translations) {
        calendarUrl = calendar.translations[0].url; // FIXME: needs to work for localized calendars
      }
      if (calendar && calendar.id === 31) {
        calendarUrl = 'https://culturelaval.caligram.com'; // FIXME: should not be hardcoded; add option in calendar settings?
      }
      var params = {
        per: number,
        organizations: organizationId,
        tags: tagsId.join(','),
        types: typesId.join(','),
        regions: regions.map(function (r) {
          return r.value;
        }).join(','),
        recurrences: !hideRecurrences
      };
      var url = calendarUrl + '/widget?' + _queryString2.default.stringify(params, { arrayFormat: 'comma', skipNull: true });
      var code = '<iframe frameborder="0" width="' + width + '" height="' + height + '" type="text/html" src="' + url + '"></iframe>';
      var popoverContainer = this;

      return _react2.default.createElement(
        _components.Loader,
        { loaded: !loading && loaded },
        _react2.default.createElement(
          'div',
          { className: 'modal-body widget' },
          _react2.default.createElement(
            'div',
            { className: 'event-form' },
            _react2.default.createElement('button', {
              type: 'button',
              onClick: requireCloseModal,
              className: 'close-modal-button icon-cg-close'
            }),
            _react2.default.createElement(
              'h1',
              null,
              polyglot.t('calendars.createWidget')
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Grid,
            { fluid: true },
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 3 },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    null,
                    polyglot.t('calendars.widget.width')
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup,
                    null,
                    _react2.default.createElement(_reactBootstrap.FormControl, {
                      value: width,
                      type: 'text',
                      pattern: '[0-9]',
                      onChange: function onChange(event) {
                        return _this3.setState({ width: event.target.value.replace(/\D/, '') });
                      },
                      placeholder: polyglot.t('calendars.widget.width')
                    }),
                    _react2.default.createElement(
                      _reactBootstrap.InputGroup.Addon,
                      null,
                      'pixels'
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    null,
                    polyglot.t('calendars.widget.height')
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.InputGroup,
                    null,
                    _react2.default.createElement(_reactBootstrap.FormControl, {
                      value: height,
                      type: 'text',
                      pattern: '[0-9]',
                      onChange: function onChange(event) {
                        return _this3.setState({ height: event.target.value.replace(/\D/, '') });
                      },
                      placeholder: polyglot.t('calendars.widget.height')
                    }),
                    _react2.default.createElement(
                      _reactBootstrap.InputGroup.Addon,
                      null,
                      'pixels'
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    null,
                    polyglot.t('calendars.widget.number')
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, {
                    value: number,
                    type: 'text',
                    pattern: '[0-9]',
                    onChange: function onChange(event) {
                      return _this3.setState({ number: event.target.value.replace(/\D/, '') });
                    },
                    placeholder: polyglot.t('calendars.widget.number')
                  })
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    null,
                    polyglot.t('calendars.widget.filters')
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_components.TypeBox, {
                      popoverContainer: popoverContainer,
                      selectedTypes: types,
                      onChange: this.handleChangeTypes.bind(this),
                      errors: errors.types || [],
                      polyglot: polyglot,
                      required: false
                    }),
                    _react2.default.createElement(_components.TagBox, {
                      popoverContainer: popoverContainer,
                      onChange: this.handleChangeTags.bind(this),
                      selectedTags: tags,
                      errors: errors.tags || [],
                      polyglot: polyglot,
                      required: false
                    }),
                    _react2.default.createElement(_components.OrganizationBox, {
                      popoverContainer: popoverContainer,
                      onChange: this.handleChangeOrganization.bind(this),
                      organization: organization,
                      polyglot: polyglot
                    }),
                    calendar && calendar.regions && calendar.regions.length > 0 && _react2.default.createElement(_reactSelect2.default, {
                      isMulti: true,
                      className: 'react-select',
                      classNamePrefix: 'react-select',
                      options: calendar.regions.map(function (r) {
                        return { value: r.id, label: r.name };
                      }),
                      value: regions,
                      onChange: this.handleChangeRegions.bind(this),
                      placeholder: polyglot.t('events.venueBox.chooseRegion'),
                      noOptionsMessage: function noOptionsMessage(query) {
                        if (query.inputValue.length <= 2) {
                          return polyglot.t('simpleSelect.typeSome');
                        }

                        return _react2.default.createElement(
                          'div',
                          { className: 'no-results-found' },
                          _this3.state.loading ? polyglot.t('events.loading') : polyglot.t('events.typeBox.noResults')
                        );
                      }
                    }),
                    _react2.default.createElement(
                      _reactBootstrap.Checkbox,
                      { checked: hideRecurrences, onChange: this.handleChangeRecurrence.bind(this) },
                      polyglot.t('calendars.widget.hideRecurrences')
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 9 },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    null,
                    'Aper\xE7u'
                  ),
                  _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: code } })
                )
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 12 },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    null,
                    'Code'
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Well,
                    null,
                    _react2.default.createElement(
                      _reactBootstrap.Row,
                      null,
                      _react2.default.createElement(
                        _reactBootstrap.Col,
                        { sm: 10 },
                        code
                      ),
                      _react2.default.createElement(
                        _reactBootstrap.Col,
                        { sm: 2 },
                        _react2.default.createElement(
                          _reactCopyToClipboard.CopyToClipboard,
                          { text: code, onCopy: this.handleCopy.bind(this) },
                          _react2.default.createElement(
                            _reactBootstrap.Button,
                            { bsStyle: 'primary', disabled: this.state.copied, block: true },
                            polyglot.t(this.state.copied ? 'calendars.widget.copied' : 'calendars.widget.copy')
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return EventWidgetForm;
}(_react.Component), _class2.propTypes = {
  calendar: _propTypes2.default.object,
  calendarId: _propTypes2.default.number,
  closeModal: _propTypes2.default.func,
  find: _propTypes2.default.func,
  loaded: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  polyglot: _propTypes2.default.object.isRequired,
  requireCloseModal: _propTypes2.default.func,
  save: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = EventWidgetForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Event/EventWidgetForm.js
// module id = 2196
// module chunks = 0